export const sortByName = (a, b) => {
  if (!a?.name) return 1;
  if (!b?.name) return -1;
  return a.name.toUpperCase().localeCompare(b.name.toUpperCase());
};

export const arrayEquals = (a, b) => {
  if (!a || !b) return false;
  if (a.length !== b.length) return false;
  const sortedA = [...a].sort();
  const sortedB = [...b].sort();
  return sortedA.every((value, i) => value === sortedB[i]);
};

export const arrayObjectEquals = (a, b) => {
  if (!a || !b) return false;
  if (a.length !== b.length) return false;
  const sortedA = [...a].sort((obj1, obj2) => obj1.id - obj2.id);
  const sortedB = [...b].sort((obj1, obj2) => obj1.id - obj2.id);
  return sortedA.every((obj, i) => obj.id === sortedB[i].id);
};

export const arrayMove = (array, from, to) => {
  const remainingItems = [...array.slice(0, from), ...array.slice(from + 1)];
  const removedItem = array[from];
  return [
    ...remainingItems.slice(0, to),
    removedItem,
    ...remainingItems.slice(to)
  ];
};
